const OUTCOME_TYPE = "ISLO";
const INGRESS_POINT = "ISLO_FILE_UPLOAD";
const OBJECT_TYPE = "outcome";

const enrichILOs = (termId, autoApprove) => {
  return {
    object_type: OBJECT_TYPE,
    context_id: OUTCOME_TYPE,
    outcome_type: OUTCOME_TYPE,
    context_type: null,
    ingress_point: INGRESS_POINT,
    effective_term_id: termId,
    archive_term_id: termId,
    auto_approve: autoApprove,
  };
};

export { enrichILOs, OUTCOME_TYPE };
